import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import settings from './modules/settings'
import user from './modules/user'

Vue.use(Vuex)
console.log(getters.user,'getters')
const store = new Vuex.Store({
  modules: {
    settings,
    user
  },
  getters
})

export default store